import React, {useEffect} from "react";
import FooterSection from "./FooterSection";
import { useSector } from "./SectorContext";
import useReveal from "./hooks/useReveal";
import CertsSection from "./CertSection"
import { Await } from "react-router-dom";
import AwardSection from "./AwardSection";
import { useLocation } from "react-router-dom";




const storyChapters = [
  {
    number: "01",
    label: "Curiosity",
    title: "Beneath the surface",
    paragraphs: [
      "I’ve always been curious about what happens beneath the surface—how things work technically, structurally, and sometimes unexpectedly. Early in my career, that curiosity led me into parts of the tools and systems around me that others considered esoteric. I enjoyed exploring them, understanding their logic, and discovering what else they could do.",
      "Over time, I realized that my tinkering extended beyond technology. I was equally fascinated by how people work “under the hood”: how we interpret the world, connect with ideas, and make decisions. That curiosity helped me develop a valuable skill, the ability to bring language and clarity to complex or nuanced issues, making ideas that once felt out of reach easier for others to understand and embrace.",
    ],
  },
  {
    number: "02",
    label: "Creative leadership",
    title: "Ideas, influence & execution",
    paragraphs: [
      "That interest in influence, communication, and storytelling led me into creative production and advertising. What began as a creative pursuit eventually developed into agency leadership, where I helped guide projects from early business conversations through strategy, creative development, production, and delivery.",
      "Along the way, I learned that strong ideas are rarely enough on their own. They also require clear objectives, capable teams, disciplined execution, and a genuine understanding of the people they are intended to reach.",
    ],
  },
  {
    number: "03",
    label: "Technology",
    title: "From interfaces to infrastructure",
    paragraphs: [
      "A conversation with an IT professional later sparked a deeper interest in technology. I initially approached web development as a natural complement to my creative skill set, but it quickly became much more than that. I fell in love with translating creative thinking into functional interfaces and working applications; a new language for solving problems, grounded in both imagination and logic.",
      "Eventually, the same curiosity drew me beneath the interface and into cybersecurity. I became interested not only in how systems are built, but in how they fail, how weaknesses can form paths to compromise, and how technical findings can become practical insight for the people responsible for protecting an organization.",
    ],
  },
];

// Add verified award records here as they are curated.
const awards = [];

function AboutPage() {


  

  const { activeSector } = useSector();
  const credentials = activeSector?.certData ?? activeSector?.certs ?? [];

  useReveal();

const location = useLocation();

useEffect(() => {
 document.title = "About Valentino Lloyd | Creative Leadership & Cybersecurity";

  if (!location.hash) return;

  const target = document.querySelector(location.hash);

  if (target) {
    requestAnimationFrame(() => {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  }
}, [location.hash]);





  return (
    <>
      <main className={`about-page ${activeSector.colorClass}`}>
        <section className="about-hero" data-reveal>
          <div className="about-image-wrap shiny-border">
            <img
              src="Profile1.webp"
              alt="Valentino Lloyd"
              className="about-image"
            />
          </div>

          <div className="about-copy">
            <p className="about-kicker">About</p>

            <h1>
              Strategy, creativity, and problem solving shaped by experience.
            </h1>

            <div className="about-text">
              <p>
                I’m Valentino Lloyd, a creative leader whose
                path has moved through advertising, web development, and
                cybersecurity. Different disciplines, connected by one enduring
                instinct: to understand a problem clearly enough to build
                something better.
              </p>
            </div>
          </div>

          {/* <a className="about-scroll-cue" href="#my-story">
            <span>My story</span>
            <span aria-hidden="true">↓</span>
          </a> */}
        </section>

        <section className="about-story" id="my-story">
          <header className="about-section-heading" data-reveal>
            <p className="about-kicker">The path here</p>
            {/* <h2>One curiosity. Three connected disciplines.</h2> */}
          </header>

          <div className="about-chapters">
            {storyChapters.map((chapter, index) => (
              <article
                className="about-chapter"
                data-reveal={index % 2 ? "right" : "left"}
                key={chapter.number}
              >
                <div className="about-chapter-meta" aria-hidden="true">
                  {/* <span>{chapter.number}</span>
                  <span>{chapter.label}</span> */}
                </div>

                <div className="about-chapter-copy">
                  <h3>{chapter.title}</h3>
                  {chapter.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>

          <blockquote className="about-pullquote" data-reveal="scale">
            Today, I work at the intersection of creativity, business, and
            technology looking beneath the surface, finding clarity in
            complexity, and helping build something better.
          </blockquote>
        </section>

{/* CertSection Here */}
        <section className="about-credentials" data-reveal>
          <header className="about-section-heading">
            <p className="about-kicker">Continuous learning</p>
            <h2>A few meaningful achievements</h2>
         <CertsSection />
          </header>

        
        </section>

{/* AwardsSection Here*/}
        <section className="about-awards" id="awards" data-reveal>
          <header className="about-section-heading">
            <p className="about-kicker">Selected recognition</p>


            <h2>Awards &amp; recognition</h2>
            <p>
              Recognition earned through collaborative work with clients,
              creative teams, and production partners over the years.
            </p>
          </header>

<AwardSection />
          {/* {awards.length > 0 ? (
            <div className="about-awards-list">
              {awards.map((award, index) => (
                <article className="about-award-item" key={`${award.title}-${award.year}`}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <div>
                    <h3>{award.title}</h3>
                    <p>{award.project}</p>
                  </div>
                  <div className="about-award-meta">
                    <p>{award.organization}</p>
                    <p>{award.role}</p>
                  </div>
                  <strong>{award.year}</strong>
                </article>
              ))}
            </div>
          ) : (
            <p className="about-empty-note">
              Selected awards will appear here as the archive is curated.
            </p>
          )} */}
        </section>

        <section className="about-closing" data-reveal="scale">
          {/* <p className="about-kicker">What connects it all</p> */}
          {/* <h2>Understand deeply.<br />Build thoughtfully.</h2> */}
          {/* <p>
            Whether the challenge involves a brand, an interface, or a system,
            the work begins the same way: look closer, ask better questions,
            and make the outcome useful to people.
          </p> */}
          {/* <a className="about-cta" href="#contact">
            Let’s do it <span aria-hidden="true">↗</span>
          </a> */}
        </section>
      </main>
      <FooterSection />
    </>
  );
}

export default AboutPage;
